
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-e",
      function () {
        return require("private-next-pages/terms-e.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-e"])
      });
    }
  